<template>
  <v-data-table
    :headers="header"
    :items="itens"
    :fixed-header="true"
    :search="search"
    :items-per-page="50"
    class="table-wkf-resposivo"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Controles de Grupo</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisa"
          dense
          outlined
          single-line
          hide-details
          clearable
          v-lazy-input:debounce="400"
          class="pr-4 pl-4 search"
        ></v-text-field>
        <v-dialog persistent v-model="dialog" max-width="600px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark v-on="on">Novo</v-btn>
          </template>
          <v-card style="border: 1px solid #fff">
            <v-toolbar dark color="#042333" height="50px">
              <v-btn icon dark @click="close">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>{{ title }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="mb-6" style="min-height: 55vh">
              <v-select
                v-model="form.id_grupo"
                :items="selects.id_grupo"
                label="Grupo"
                outlined
                class="mt-10"
                item-text="descricao"
                item-value="id"
                :disabled="edit == true"
                :error-messages="errorGrupo"
                @input="$v.form.id_grupo.$touch()"
                @blur="$v.form.id_grupo.$touch()"
              ></v-select>
              <v-select
                v-model="form.id_wkf_item"
                :items="selects.id_wkf_item"
                label="Tipo Análise"
                outlined
                item-text="descricao"
                item-value="id"
                :disabled="edit == true || form.id_grupo == ''"
                :error-messages="errorItem"
                @input="$v.form.id_wkf_item.$touch()"
                @blur="$v.form.id_wkf_item.$touch()"
              ></v-select>
              <v-select
                v-model="form.valor"
                v-if="tipo == 1"
                :items="selects.valor"
                label="Valor*"
                outlined
                :error-messages="errorValor"
                @input="$v.form.valor.$touch()"
                @blur="$v.form.valor.$touch()"
              ></v-select>

              <v-row v-if="tipo == 2">
                <v-col></v-col>
                <v-col cols="auto pr-0">Valor Máximo e Mínimo</v-col>
                <v-col cols="auto mb-2 pl-0">
                  <v-switch v-model="maxmin" hide-details></v-switch>
                </v-col>
              </v-row>
              <v-text-field
                v-model="form.valor"
                v-if="tipo == 2 && !maxmin"
                outlined
                label="Valor(%)*"
                v-currency="number"
                :error-messages="errorValor"
                @input="$v.form.valor.$touch()"
                @blur="$v.form.valor.$touch()"
                ref="valor"
              ></v-text-field>

              <v-text-field
                v-model="form.max"
                v-if="maxmin"
                outlined
                label="Valor Max(%)*"
                v-currency="number"
                :error-messages="errorValorMax"
                @input="$v.form.max.$touch()"
                @blur="$v.form.max.$touch()"
                ref="max"
              ></v-text-field>

              <v-text-field
                v-model="form.min"
                v-if="maxmin"
                outlined
                label="Valor Min(%)*"
                v-currency="number"
                :error-messages="errorValorMin"
                @input="$v.form.min.$touch()"
                @blur="$v.form.min.$touch()"
                ref="min"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="white" @click="close()">Cancelar</v-btn>
              <v-btn color="#042333" dark @click="salvar">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-btn icon title="Editar Controle de Grupo" @click="editar(item)">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-btn icon title="Remover Controle de Grupo" @click="excluir(item)">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </template>
    <template v-slot:item.valor="{ item }">
      <div v-if="item.valor == 's'">Sim</div>
      <div v-else-if="item.valor == 'n'">Não</div>
      <div v-else>
        <template v-if="item.max">
          MIN:{{
            Helpers.formatarValorMonetario(item.min / 100).replace("R$", "")
          }}% | MAX:{{
            Helpers.formatarValorMonetario(item.max / 100).replace("R$", "")
          }}%
        </template>
        <template v-else>
          {{
            Helpers.formatarValorMonetario(item.valor / 100).replace("R$", "")
          }}
        </template>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import Api from "../../../api/cfg";

export default {
  data() {
    return {
      header: [
        { text: "Grupo", value: "grupo" },
        { text: "Item de Análise", value: "item" },
        { text: "Valor", value: "valor", align: "center" },
        { value: "action", sortable: false, width: "100px", align: "center" },
      ],
      search: "",
      maxmin: false,
      dialog: false,
      title: "Novo Controle de Grupo",
      form: {
        id_grupo: "",
        id_wkf_item: "",
        valor: "",
        min: "",
        max: "",
      },
      selects: {
        id_wkf_item: [],
        id_grupo: [],
        valor: [
          { value: "s", text: "Sim" },
          { value: "n", text: "Não" },
        ],
      },
      number: {
        currency: null,
        distractionFree: { hideCurrencySymbol: false },
        precision: 2,
        allowNegative: false,
        valueAsInteger: true,
        autoDecimalMode: true,
        valueRange: { min: 0, max: 100 },
      },
      soGrupo: [],
      tipo: "",
      edit: false,
    };
  },
  validations: {
    form: {
      id_grupo: { required },
      id_wkf_item: { required },
      valor: {
        required() {
          if (!this.maxmin && this.form.valor == "") return false;
          else return true;
        },
      },
      max: {
        required() {
          if (this.maxmin && this.form.max == "") return false;
          else return true;
        },
      },
      min: {
        required() {
          if (this.maxmin && this.form.min == "") return false;
          else return true;
        },
      },
    },
  },
  computed: {
    ...mapGetters("wkfControleGrupo", ["itens"]),
    ...mapGetters("wkfItem", { soItem: "itens" }),
    errorGrupo() {
      const errors = [];
      if (!this.$v.form.id_grupo.$dirty) return errors;
      !this.$v.form.id_grupo.required && errors.push("O grupo é obrigatório.");
      return errors;
    },
    errorItem() {
      const errors = [];
      if (!this.$v.form.id_wkf_item.$dirty) return errors;
      !this.$v.form.id_wkf_item.required &&
        errors.push("O tipo de análise é obrigatório.");
      return errors;
    },
    errorValor() {
      const errors = [];
      if (!this.$v.form.valor.$dirty) return errors;
      !this.$v.form.valor.required && errors.push("O valor é obrigatório.");
      return errors;
    },
    errorValorMax() {
      const errors = [];
      if (!this.$v.form.max.$dirty) return errors;
      !this.$v.form.max.required &&
        errors.push("O valor máximo é obrigatório.");
      return errors;
    },
    errorValorMin() {
      const errors = [];
      if (!this.$v.form.min.$dirty) return errors;
      !this.$v.form.min.required &&
        errors.push("O valor mínimo é obrigatório.");
      return errors;
    },
  },
  created() {
    this.$store.dispatch("wkfControleGrupo/Itens");
    this.select();
  },
  methods: {
    excluir(item) {
      if (confirm("Deseja remover aplicativo?")) {
        this.$store.dispatch("wkfControleGrupo/Delete", item);
      }
    },
    editar(prop) {
      this.dialog = true;
      this.edit = true;
      this.form.id_grupo = prop.id_grupo;
      this.form.id_wkf_item = prop.id_wkf_item;
      this.maxmin = prop.max ? true : false;
      setTimeout(() => {
        this.form.valor = prop.valor
          ? (parseInt(prop.valor) / 100).toFixed(2).replace(".", ",")
          : "";
        this.form.max = prop.max
          ? (parseInt(prop.max) / 100).toFixed(2).replace(".", ",")
          : "";
        this.form.min = prop.min
          ? (parseInt(prop.min) / 100).toFixed(2).replace(".", ",")
          : "";
      }, 300);

      this.title = "Editar Controle de Grupo";
      this.$v.$reset();
    },
    salvar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.maxmin) {
          this.form.valor = "";
        } else {
          this.form.max = "";
          this.form.min = "";
        }
        this.$store
          .dispatch("wkfControleGrupo/Store", this.form)
          .then(() => {
            this.close();
          })
          .catch((e) => {
            if (e.response.data.errors) {
              this.$v.$reset();
              this.$v.$touch();
            } else {
              this.Helpers.logout();
            }
          });
      }
    },
    close() {
      this.title = "Novo Controle de Grupo";
      this.edit = false;
      this.form = {
        id_grupo: "",
        id_wkf_item: "",
        valor: "",
        min: "",
        max: "",
      };
      this.tipo = "";
      this.dialog = false;
      this.maxmin = false;
      this.$v.$reset();
    },
    select() {
      const headers = this.Helpers.iniciarRequisicao();
      Api.getGrupos(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);
          if (response.status == 200) {
            this.soGrupo = response.data.grupos;
            this.selects.id_grupo = response.data.grupos;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
      this.selects.id_wkf_item = [...this.soItem];
    },
    groupBy(items, key) {
      return items.reduce(
        (result, item) => ({
          ...result,
          [item[key]]: [...(result[item[key]] || []), item],
        }),
        {}
      );
    },
  },
  watch: {
    dialog() {
      this.selects.id_grupo = [...this.soGrupo];
      if (!this.edit) {
        const grupo = this.groupBy(this.itens, "grupo");
        Object.keys(grupo).forEach((g) => {
          if (this.form.id_grupo != grupo[g][0].id_grupo) {
            if (grupo[g].length == this.selects.id_wkf_item.length) {
              this.selects.id_grupo = this.selects.id_grupo.filter(
                (f) => f.descricao != g
              );
            }
          }
        });
      }
    },
    "form.id_wkf_item"() {
      if (this.form.id_wkf_item) {
        this.tipo = this.selects.id_wkf_item.find(
          (s) => s.id == this.form.id_wkf_item
        ).tipo;
        if (!this.edit) {
          this.form.valor = "";
          this.$v.$reset();
        }
      }
    },
    "form.id_grupo"() {
      this.selects.id_wkf_item = [...this.soItem];
      if (!this.edit) {
        const item = this.groupBy(
          this.itens.filter((i) => i.id_grupo == this.form.id_grupo),
          "grupo"
        );
        Object.keys(item).forEach((it) => {
          item[it].forEach((i) => {
            if (this.form.id_wkf_item != i.id_wkf_item)
              this.selects.id_wkf_item = this.selects.id_wkf_item.filter(
                (f) => f.id != i.id_wkf_item
              );
          });
        });
        this.form.id_wkf_item = "";
        this.form.valor = "";
        this.tipo = "";
        this.$v.$reset();
      }
    },
  },
};
</script>
